import {
  GET_CLAIM_INFORMATION,
  GET_CLAIM_INFORMATION_ERROR,
  GET_CLAIM_INFORMATION_SUCCESS
} from './ClaimsReceivedSection.actions'

const claimListState = {
  loading: true,
  error: undefined,
  rangeDate: {
    initialMonth: null,
    initialYear: null,
    finalMonth: null,
    finalYear: null
  },
  chartData: [
    {
      name: '',
      id: 0,
      orders: 0,
      amount: 0,
      percentage: 0,
      dateUpdate: '',
      color: ''
    }
  ],
  totalClaim: 0,
  claimsIrregularity: 0,
  paymentNotTime: 0,
  hasData: false
}

/**
 * The claim ListReducer .
 */
const claimListReducer = (state = claimListState, { payload, type }) => {
  switch (type) {
    case GET_CLAIM_INFORMATION: {
      return { ...state, loading: true }
    }
    case GET_CLAIM_INFORMATION_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_CLAIM_INFORMATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        chartData: payload?.chartData,
        totalClaim: payload?.totalClaim,
        claimsIrregularity: payload?.claimsIrregularity,
        paymentNotTime: payload?.paymentNotTime,
        rangeDate: payload?.rangeDate,
        hasData: payload?.hasData
      }
    }
    default: {
      return state
    }
  }
}

export default claimListReducer
